/**
 * The eight Tailwind-500 swatches shown wherever the user picks a label
 * color. Centralised so the inbox rail's quick-create popover and the
 * Labels management tab can't drift apart.
 */
export const LABEL_COLOR_SWATCHES: string[] = [
  '#ef4444', // red-500
  '#f97316', // orange-500
  '#eab308', // yellow-500
  '#22c55e', // green-500
  '#06b6d4', // cyan-500
  '#3b82f6', // blue-500
  '#a855f7', // purple-500
  '#ec4899', // pink-500
];
